module.exports = __webpack_public_path__ + "assets/img/fr-11be2f54.png";